import React from 'react';

const Index = () => {
  return (
    <svg viewBox='0 0 32 20' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g id='Group 47336'>
        <path id='Vector 1'
              d='M10.2611 9.99999V0.10791H0.293518V7.5836C0.293518 8.86731 1.50171 9.99999 2.7099 9.99999H10.2611Z'
              fill='current'/>
        <path id='Vector 2'
              d='M11.7713 19.8921L11.7713 0.10791L31.7065 0.10791V4.26107C31.7065 7.65911 29.0636 10.0755 25.892 10.0755H21.6634V14.4552C21.6634 18.0043 18.9449 19.8921 16.2265 19.8921H11.7713Z'
              fill='current'/>
      </g>
    </svg>

  )
};

export default Index;
